var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4B4B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,6.1c-0.6,0-1.1,0-1.7,0c-0.1,0-0.3,0-0.4,0C7.1,6,6.6,5.4,6.6,4.7c0-0.6,0-1.2,0-1.7c0-0.1,0-0.1,0-0.2 c-0.1,0-0.1,0-0.2,0c-1,0-2.1,0-3.1,0C3,2.8,2.8,3,2.8,3.3c0,3.1,0,6.2,0,9.3c0,0.4,0.2,0.5,0.5,0.5c2,0,4,0,6,0 c0.4,0,0.5-0.2,0.5-0.5c0-0.4,0-0.9,0-1.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.4,0,0.9,0,1.3c0,0.8-0.6,1.4-1.4,1.4 c-2,0-4.1,0-6.1,0c-0.8,0-1.4-0.6-1.4-1.4c0-3.1,0-6.3,0-9.4c0-0.8,0.6-1.4,1.4-1.4c1.2,0,2.5,0,3.7,0c0.2,0,0.3,0.1,0.4,0.2 c1.1,1.1,2.2,2.2,3.2,3.2c0.1,0.1,0.2,0.2,0.2,0.4c0,0.6,0,1.2,0,1.8c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5 C9.9,7,9.9,6.6,9.9,6.1z M9.1,5.2C8.6,4.6,8.1,4.1,7.5,3.5c0,0.4,0,0.8,0,1.2C7.5,5,7.7,5.2,8,5.2C8.4,5.2,8.8,5.2,9.1,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,8.9c-0.1-0.1-0.1-0.1-0.1-0.1c-0.3-0.3-0.6-0.6-0.9-0.9c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0 c0.6,0.6,1.2,1.2,1.8,1.8c0.2,0.2,0.2,0.5,0,0.7c-0.6,0.6-1.2,1.2-1.8,1.8c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7 c0.3-0.3,0.6-0.6,0.9-0.9c0,0,0.1-0.1,0.1-0.1c-0.1,0-0.1,0-0.2,0c-1.6,0-3.2,0-4.8,0C7.2,9.9,7,9.6,7.1,9.2 c0.1-0.2,0.2-0.3,0.5-0.3c0.5,0,1,0,1.4,0c1.1,0,2.2,0,3.4,0C12.4,8.9,12.4,8.9,12.5,8.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExport);
export default __webpack_public_path__ + "static/media/import-export.ceb27ef3e242d839b691027fae412fd5.svg";
export { ForwardRef as ReactComponent };